export default __webpack_public_path__ + "static/media/clinks.00910fe0.svg";